import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { Link } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import { useSelector } from "react-redux";

// JSON data for countries and states
import countriesData from "./countries.json";
import statesData from "./states.json";

const Address = () => {
  const translation = useSelector(state => state.root.translation);
  const route = all_routes;
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [area, setArea] = useState("");
  const [address, setAddress] = useState("");
  const [errors, setErrors] = useState({});

  const [useSamePickup, setUseSamePickup] = useState(true);
  const [useSameReturn, setUseSameReturn] = useState(true);
  const [useSameBilling, setUseSameBilling] = useState(true);

  const [pickupCountry, setPickupCountry] = useState("");
  const [pickupState, setPickupState] = useState("");
  const [pickupZipCode, setPickupZipCode] = useState("");
  const [pickupArea, setPickupArea] = useState("");
  const [pickupAddress, setPickupAddress] = useState("");

  const [returnCountry, setReturnCountry] = useState("");
  const [returnState, setReturnState] = useState("");
  const [returnZipCode, setReturnZipCode] = useState("");
  const [returnArea, setReturnArea] = useState("");
  const [returnAddress, setReturnAddress] = useState("");

  const [billingCountry, setBillingCountry] = useState("");
  const [billingState, setBillingState] = useState("");
  const [billingZipCode, setBillingZipCode] = useState("");
  const [billingArea, setBillingArea] = useState("");
  const [billingAddress, setBillingAddress] = useState("");

  const validate = () => {
    const errors = {};
    if (!selectedCountry) {
      errors.country = translation?.select_country;
    }
    if (!selectedState) {
      errors.state = translation?.select_state;
    }
    if (!zipCode.trim()) {
      errors.zipCode = translation?.select_zip_code;
    }
    if (!area.trim()) {
      errors.area = translation?.select_area;
    }
    if (!address.trim()) {
      errors.address = translation?.select_address;
    }
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleNext = (e) => {
    e.preventDefault();
    if (validate()) {
      const previousformData = location.state;
      previousformData.tenant.address = {
        country: selectedCountry,
        state: selectedState,
        zipCode,
        area,
        address,
      };
      previousformData.tenant.pickupAddress = useSamePickup
        ? previousformData.tenant.address
        : {
            country: pickupCountry,
            state: pickupState,
            zipCode: pickupZipCode,
            area: pickupArea,
            address: pickupAddress,
          };
          previousformData.tenant.returnAddress = useSameReturn
        ? previousformData.tenant.address
        : {
            country: returnCountry,
            state: returnState,
            zipCode: returnZipCode,
            area: returnArea,
            address: returnAddress,
          };
          previousformData.tenant.billingAddress = useSameBilling
        ? previousformData.tenant.address
        : {
            country: billingCountry,
            state: billingState,
            zipCode: billingZipCode,
            area: billingArea,
            address: billingAddress,
          };

      console.log(previousformData); // You can send this formData to the next step/component
      navigate(route.idverification, { state: previousformData });
    }
  };

  // Filter states based on the selected country
  const filteredStates = statesData[selectedCountry] || [];
  const filteredPickupStates = statesData[pickupCountry] || [];
  const filteredReturnStates = statesData[returnCountry] || [];
  const filteredBillingStates = statesData[billingCountry] || [];

  return (
    <div className="main-wrapper">
      <div className="account-content">
        <div className="login-wrapper">
        <div className="login-img">
            <ImageWithBasePath src="assets/img/authentication/login02.png" alt="img" />
          </div>
          <div className="login-content">
            <form action="signin" style={{ width: "80%" }}>
              <div className="login-userset">
                <div className="login-logo logo-normal">
                  <ImageWithBasePath src="assets/img/logo.png" alt="img" />
                </div>
                <Link to={route.dashboard} className="login-logo logo-white">
                  <ImageWithBasePath
                    src="assets/img/logo-white.png"
                    alt="img"
                  />
                </Link>
                <div className="login-userheading">
                  <h3>{translation?.profile} -{">"} {translation?.store_address}</h3>
                </div>
                <div className="form-login">
                  <label>{translation?.country}</label>
                  <div className="form-addons">
                    <select
                      className="form-control"
                      value={selectedCountry}
                      onChange={(e) => setSelectedCountry(e.target.value)}
                    >
                      <option value="">{translation?.select_country_option}</option>
                      {countriesData.map((country) => (
                        <option key={country.code} value={country.code}>
                          {country.name}
                        </option>
                      ))}
                    </select>
                    <ImageWithBasePath
                      src="assets/img/icons/mail.svg"
                      alt="img"
                    />
                  </div>
                  {errors.country && (
                    <span className="text-danger">{errors.country}</span>
                  )}
                </div>
                <div className="form-login">
                  <label>{translation?.state}</label>
                  <div className="form-addons">
                    <select
                      className="form-control"
                      value={selectedState}
                      onChange={(e) => setSelectedState(e.target.value)}
                    >
                      <option value="">{translation?.select_state_option}</option>
                      {filteredStates.map((state) => (
                        <option key={state.code} value={state.code}>
                          {state.name}
                        </option>
                      ))}
                    </select>
                    <ImageWithBasePath
                      src="assets/img/icons/user-icon.svg"
                      alt="img"
                    />
                  </div>
                  {errors.state && (
                    <span className="text-danger">{errors.state}</span>
                  )}
                </div>
                <div className="form-login">
                  <label>{translation?.zip_code}</label>
                  <div className="form-addons">
                    <input
                      type="text"
                      className="form-control"
                      value={zipCode}
                      onChange={(e) => setZipCode(e.target.value)}
                    />
                    <ImageWithBasePath
                      src="assets/img/icons/user-icon.svg"
                      alt="img"
                    />
                  </div>
                  {errors.zipCode && (
                    <span className="text-danger">{errors.zipCode}</span>
                  )}
                </div>
                <div className="form-login">
                  <label>{translation?.area}</label>
                  <div className="form-addons">
                    <input
                      type="text"
                      className="form-control"
                      value={area}
                      onChange={(e) => setArea(e.target.value)}
                    />
                    <ImageWithBasePath
                      src="assets/img/icons/user-icon.svg"
                      alt="img"
                    />
                  </div>
                  {errors.area && (
                    <span className="text-danger">{errors.area}</span>
                  )}
                </div>
                <div className="form-login">
                  <label>{translation?.store_address}</label>
                  <div className="form-addons">
                    <textarea
                      className="form-control"
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                    />
                    <ImageWithBasePath
                      src="assets/img/icons/user-icon.svg"
                      alt="img"
                    />
                  </div>
                  {errors.address && (
                    <span className="text-danger">{errors.address}</span>
                  )}
                </div>
                
                {/* Pickup Address Section */}
                <div className="login-userheading form-check form-switch">
                    <input
                    type="checkbox"
                    className="form-check-input"
                    checked={useSamePickup}
                    onChange={(e) => setUseSamePickup(e.target.checked)}
                  />
                  <label className="form-check-label">{translation?.pickup_address}</label> 
                  
                 
                </div>
                {!useSamePickup && (
                  <>
                    <div className="form-login">
                      <label>{translation?.country}</label>
                      <div className="form-addons">
                        <select
                          className="form-control"
                          value={pickupCountry}
                          onChange={(e) => setPickupCountry(e.target.value)}
                        >
                          <option value="">{translation?.select_country_option}</option>
                          {countriesData.map((country) => (
                            <option key={country.code} value={country.code}>
                              {country.name}
                            </option>
                          ))}
                        </select>
                        <ImageWithBasePath
                          src="assets/img/icons/mail.svg"
                          alt="img"
                        />
                      </div>
                    </div>
                    <div className="form-login">
                      <label>{translation?.state}</label>
                      <div className="form-addons">
                        <select
                          className="form-control"
                          value={pickupState}
                          onChange={(e) => setPickupState(e.target.value)}
                        >
                          <option value="">{translation?.select_state_option}</option>
                          {filteredPickupStates.map((state) => (
                            <option key={state.code} value={state.code}>
                              {state.name}
                            </option>
                          ))}
                        </select>
                        <ImageWithBasePath
                          src="assets/img/icons/user-icon.svg"
                          alt="img"
                        />
                      </div>
                    </div>
                    <div className="form-login">
                      <label>{translation?.zip_code}</label>
                      <div className="form-addons">
                        <input
                          type="text"
                          className="form-control"
                          value={pickupZipCode}
                          onChange={(e) => setPickupZipCode(e.target.value)}
                        />
                        <ImageWithBasePath
                          src="assets/img/icons/user-icon.svg"
                          alt="img"
                        />
                      </div>
                    </div>
                    <div className="form-login">
                      <label>{translation?.area}</label>
                      <div className="form-addons">
                        <input
                          type="text"
                          className="form-control"
                          value={pickupArea}
                          onChange={(e) => setPickupArea(e.target.value)}
                        />
                        <ImageWithBasePath
                          src="assets/img/icons/user-icon.svg"
                          alt="img"
                        />
                      </div>
                    </div>
                    <div className="form-login">
                      <label>{translation?.pickup_address}</label>
                      <div className="form-addons">
                        <textarea
                          className="form-control"
                          value={pickupAddress}
                          onChange={(e) => setPickupAddress(e.target.value)}
                        />
                        <ImageWithBasePath
                          src="assets/img/icons/user-icon.svg"
                          alt="img"
                        />
                      </div>
                    </div>
                  </>
                )}

                {/* Return Address Section */}
                <div className="login-userheading form-check form-switch">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={useSameReturn}
                    onChange={(e) => setUseSameReturn(e.target.checked)}
                  />
                  <label className="form-check-label">{translation?.return_address}</label> 
                </div>
                {!useSameReturn && (
                  <>
                    <div className="form-login">
                      <label>{translation?.country}</label>
                      <div className="form-addons">
                        <select
                          className="form-control"
                          value={returnCountry}
                          onChange={(e) => setReturnCountry(e.target.value)}
                        >
                          <option value="">{translation?.select_country_option}</option>
                          {countriesData.map((country) => (
                            <option key={country.code} value={country.code}>
                              {country.name}
                            </option>
                          ))}
                        </select>
                        <ImageWithBasePath
                          src="assets/img/icons/mail.svg"
                          alt="img"
                        />
                      </div>
                    </div>
                    <div className="form-login">
                      <label>{translation?.state}</label>
                      <div className="form-addons">
                        <select
                          className="form-control"
                          value={returnState}
                          onChange={(e) => setReturnState(e.target.value)}
                        >
                          <option value="">{translation?.select_state_option}</option>
                          {filteredReturnStates.map((state) => (
                            <option key={state.code} value={state.code}>
                              {state.name}
                            </option>
                          ))}
                        </select>
                        <ImageWithBasePath
                          src="assets/img/icons/user-icon.svg"
                          alt="img"
                        />
                      </div>
                    </div>
                    <div className="form-login">
                      <label>{translation?.zip_code}</label>
                      <div className="form-addons">
                        <input
                          type="text"
                          className="form-control"
                          value={returnZipCode}
                          onChange={(e) => setReturnZipCode(e.target.value)}
                        />
                        <ImageWithBasePath
                          src="assets/img/icons/user-icon.svg"
                          alt="img"
                        />
                      </div>
                    </div>
                    <div className="form-login">
                      <label>{translation?.area}</label>
                      <div className="form-addons">
                        <input
                          type="text"
                          className="form-control"
                          value={returnArea}
                          onChange={(e) => setReturnArea(e.target.value)}
                        />
                        <ImageWithBasePath
                          src="assets/img/icons/user-icon.svg"
                          alt="img"
                        />
                      </div>
                    </div>
                    <div className="form-login">
                      <label>{translation?.return_address}</label>
                      <div className="form-addons">
                        <textarea
                          className="form-control"
                          value={returnAddress}
                          onChange={(e) => setReturnAddress(e.target.value)}
                        />
                        <ImageWithBasePath
                          src="assets/img/icons/user-icon.svg"
                          alt="img"
                        />
                      </div>
                    </div>
                  </>
                )}

                {/* Billing Address Section */}
                <div className="login-userheading form-check form-switch">
                 <input
                    type="checkbox"
                    className="form-check-input"
                    checked={useSameBilling}
                    onChange={(e) => setUseSameBilling(e.target.checked)}
                  />
                  <label className="form-check-label">{translation?.billing_address}</label>
                </div>
                <div className="form-login">
                
                </div>
                {!useSameBilling && (
                  <>
                    <div className="form-login">
                      <label>{translation?.country}</label>
                      <div className="form-addons">
                        <select
                          className="form-control"
                          value={billingCountry}
                          onChange={(e) => setBillingCountry(e.target.value)}
                        >
                          <option value="">{translation?.select_country_option}</option>
                          {countriesData.map((country) => (
                            <option key={country.code} value={country.code}>
                              {country.name}
                            </option>
                          ))}
                        </select>
                        {/* <ImageWithBasePath
                          src="assets/img/icons/mail.svg"
                          alt="img"
                        /> */}
                      </div>
                    </div>
                    <div className="form-login">
                      <label>{translation?.state}</label>
                      <div className="form-addons">
                        <select
                          className="form-control"
                          value={billingState}
                          onChange={(e) => setBillingState(e.target.value)}
                        >
                          <option value="">{translation?.select_state_option}</option>
                          {filteredBillingStates.map((state) => (
                            <option key={state.code} value={state.code}>
                              {state.name}
                            </option>
                          ))}
                        </select>
                        {/* <ImageWithBasePath
                          src="assets/img/icons/user-icon.svg"
                          alt="img"
                        /> */}
                      </div>
                    </div>
                    <div className="form-login">
                      <label>{translation?.zip_code}</label>
                      <div className="form-addons">
                        <input
                          type="text"
                          className="form-control"
                          value={billingZipCode}
                          onChange={(e) => setBillingZipCode(e.target.value)}
                        />
                        <ImageWithBasePath
                          src="assets/img/icons/user-icon.svg"
                          alt="img"
                        />
                      </div>
                    </div>
                    <div className="form-login">
                      <label>{translation?.area}</label>
                      <div className="form-addons">
                        <input
                          type="text"
                          className="form-control"
                          value={billingArea}
                          onChange={(e) => setBillingArea(e.target.value)}
                        />
                        <ImageWithBasePath
                          src="assets/img/icons/user-icon.svg"
                          alt="img"
                        />
                      </div>
                    </div>
                    <div className="form-login">
                      <label>{translation?.billing_address}</label>
                      <div className="form-addons">
                        <textarea
                          className="form-control"
                          value={billingAddress}
                          onChange={(e) => setBillingAddress(e.target.value)}
                        />
                       <ImageWithBasePath
                          src="assets/img/icons/mail.svg"
                          alt="img"
                        />
                      </div>
                    </div>
                  </>
                )}

                <div className="form-login">
                  <button className="btn btn-login" onClick={handleNext}>
                    Next
                  </button>
                </div>
                <div className="my-4 d-flex justify-content-center align-items-center copyright-text">
                  <p>{translation?.copyright_message}</p>
                </div>
              </div>
            </form>
          </div>
         
        </div>
      </div>
    </div>
  );
};

export default Address;